<ng-container *ngIf="customFields && customFields.length > 0">
    <mat-expansion-panel
        [expanded]="true"
        #mainExpansionPanelSpecifications
        class="user-manage-course-expantion main-panel"
    >
        <mat-expansion-panel-header>
            <mat-icon>tune</mat-icon>
            <div [ngClass]="{ 'main-info-label': mainExpansionPanelSpecifications.expanded }" i18n="@@Customization">
                Customization
            </div>
        </mat-expansion-panel-header>
        <mat-expansion-panel
            *ngFor="let customField of customFieldFormArray.controls; let odd = odd; let even = even"
            [formGroup]="customField | cast"
            [ngClass]="{ odd: odd, even: even }"
            #customFieldExpansionPanel
            class="user-manage-course-expantion"
        >
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <mat-icon [matTooltip]="(customField.value.type | formBuilderItemPipe).label">{{
                        (customField.value.type | formBuilderItemPipe).icon
                    }}</mat-icon>
                    <div i18n>{{ Utils.getValueFromTranslation(customField.value.name, localeId) }}</div>

                    <mat-icon class="icon-explain" [matTooltip]="(customField.value.type | formBuilderItemPipe).label"
                        >help_outline</mat-icon
                    >
                </mat-panel-title>
            </mat-expansion-panel-header>
            <app-custom-fields [customFieldForm]="customField | cast"></app-custom-fields>
        </mat-expansion-panel>
    </mat-expansion-panel>
</ng-container>
